import { Button } from '@mui/material';
import { useTour } from '@reactour/tour';
import React from 'react';

function TourButton() {
  const { setIsOpen } = useTour();

  return (
    <Button
      variant="contained"
      size="small"
      style={{
        padding: '3px 10px',
      }}
      onClick={() => setIsOpen(true)}
    >
      Start Tour
    </Button>
  );
}

export default TourButton;
